import React, { useState, useEffect, useRef } from "react";
import Header from "./Header.js";
import Footer from "./Footer.js";

import { TailSpin } from "react-loader-spinner";
import Select from "react-select";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Style.css";
import Add_PrivacyPolicy from "../../Components/Admin_components/add_PrivacyPolicy.js";
import Update_Policy from "../../Components/Admin_components/update_PrivacyPolicy.js";
import Delete_Policy from "../../Components/Admin_components/delete_privacyPolicy.js";
import "../../Api/apiUrls.js";
import {API_URL, getPrivacyPolicies} from "../../Api/apiUrls";


function PrivacyPolicy() {
  const [modalAdd_PrivacyPolicyIsOpen, setAdd_PrivacyPolicyModalIsOpen] =
    useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [Policy, setPolicy] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [modalUpdate_PrivacyPolicyIsOpen, setUpdate_PrivacyPolicyModalIsOpen] =
    useState(false);
  const [modalDelete_PrivacyPolicyIsOpen, setDelete_PrivacyPolicyIsOpen] =
    useState(false);
  // const [selectedUserId, setSelectedUserId] = useState(null);
  const Status = [
    { value: "All", label: "All" },
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];
  const openAdd_PrivacyPolicy = () => {
    closeAddPrivacyPolicy();
    setAdd_PrivacyPolicyModalIsOpen(true);
  };

  const closeAddPrivacyPolicy = () => {
    setAdd_PrivacyPolicyModalIsOpen(false);
  };

  const openUpdate_PrivacyPolicy = (policyId, Policy) => {
    setSelectedUserId(policyId);
    setSelectedPolicy(Policy);
    closeUpdate_PrivacyPolicy();
    setUpdate_PrivacyPolicyModalIsOpen(true);
  };

  const closeUpdate_PrivacyPolicy = () => {
    setUpdate_PrivacyPolicyModalIsOpen(false);
  };
  const openDelete_PrivacyPolicy = (policyId) => {
    setSelectedUserId(policyId);
    closeDelete_PrivacyPolicy();
    setDelete_PrivacyPolicyIsOpen(true);
  };

  const closeDelete_PrivacyPolicy = () => {
    setDelete_PrivacyPolicyIsOpen(null);
  };

  useEffect(() => {
    fetch(`${getPrivacyPolicies}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        const policy = data.data.PrivacyPolicies;
        setPolicy(policy);
        console.log(policy);
      })
      .catch((error) => console.error("Error fetching data:", error))
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <div>
      <Header></Header>
      {modalAdd_PrivacyPolicyIsOpen && (
        <Add_PrivacyPolicy onClose={closeAddPrivacyPolicy} />
      )}
      {modalUpdate_PrivacyPolicyIsOpen && (
        <Update_Policy
          policyId={selectedUserId}
          onClose={closeUpdate_PrivacyPolicy}
        />
      )}
      {modalDelete_PrivacyPolicyIsOpen && (
        <Delete_Policy
          policyId={selectedUserId}
          onClose={closeDelete_PrivacyPolicy}
        />
      )}
      <main id="main" class="main">
        <div class="pagetitle">
          <h1> Privacy Policy</h1>
        </div>
        <section class="section">
          <div class="card p-2">
            <div class="parent col-md-12 row mt-2">
              <div class="col-md-6">
                <div class="child">
                  <input
                    id="myInput"
                    type="text"
                    style={{
                      borderRadius: "5px",
                      height: "35px",
                      padding: "10px",
                      border: "1px solid lightgrey ",
                    }}
                    placeholder="Search..."
                  />
                </div>
                <div class="child ml-2">
                  <Select options={Status} placeholder="Select Status"></Select>
                </div>
              </div>
              <div class="col-md-6" style={{ textAlign: "right" }}>
                <div class="child">
                  <a>
                    <button
                      id="btnNewUser"
                      type="button"
                      data-toggle="modal"
                      data-target="#modalAdd"
                      class="btn-round"
                      onClick={openAdd_PrivacyPolicy}
                    >
                      <i class="bi bi-person-add"></i> Add Privacy Policy
                    </button>
                  </a>
                </div>
              </div>
            </div>

            <div
              style={{ marginTop: "50px", display: "flex", marginLeft: "50%" }}
            ></div>
            {isLoading === true ? (
              <div
                style={{
                  marginTop: "50px",
                  display: "flex",
                  marginLeft: "50%",
                }}
              >
                <TailSpin color="black" width={50} />
              </div>
            ) : Policy.length > 0 ? (
              <table class="table table-striped ">
                <thead>
                  <tr>
                    <th scope="col">Sr.No</th>
                    <th scope="col">Policy</th>

                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Policy.map((Policy, index) => (
                    <tr key={Policy.id}>
                      <th scope="row">{index + 1}</th>
                      <td>{Policy.privacy_policies || "-"}</td>

                      <td>
                        <div className="social-links mt-2">
                          <a
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              openUpdate_PrivacyPolicy(
                                Policy.id,
                                Policy.privacy_policies
                              )
                            }
                          >
                            <i class="bi bi-pencil"></i>
                          </a>
                          &nbsp;&nbsp;
                          <a
                            style={{ cursor: "pointer" }}
                            onClick={() => openDelete_PrivacyPolicy(Policy.id)}
                          >
                            <i class="bi bi-trash3"></i>
                          </a>
                          &nbsp;
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <h3 style={{ textAlign: "center" }}> No data available </h3>
            )}
            {modalUpdate_PrivacyPolicyIsOpen && (
              <Update_Policy
                policyId={selectedUserId}
                Policy={selectedPolicy}
                onClose={closeUpdate_PrivacyPolicy}
              />
            )}
          </div>
        </section>
      </main>
      <Footer></Footer>
    </div>
  );
}

export default PrivacyPolicy;
